/* eslint-disable no-undef */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('@rails/ujs').start();
require('@rails/activestorage').start();
require('jquery');
require('channels');
require('app/expert_profile');
require('app/volunteers');
require('app/billing');
require('app/verification_requests');
require('app/admin');
require('app/admin/expert_profile/expertProfileAdmin.js');


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

document.addEventListener('DOMContentLoaded', () => {
  if (AD.device() === 'desktop') {
    const sidebarLinks = document.getElementsByClassName('afd-myad-sidebar__link');
    AFD.highlightLinks(sidebarLinks, 'afd-myad-sidebar__link--active');
  }
});
